import { TaxonomyHeaderInterceptor } from 'app/http/interceptors/taxonomy-header.interceptor';
import { dialogService } from 'app/services/dialog.service';

import { httpClient } from './http-client';
import { AuthHeaderInterceptor } from './interceptors/auth-header.interceptor';
import { AuthRedirectInterceptor } from './interceptors/auth-redirect.interceptor';
import { DownloadInterceptor } from './interceptors/download.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { ShowProdDataHeaderInterceptor } from './interceptors/show-prod-data-header.interceptor';
import { UpdateDetectionInterceptor } from './interceptors/update-detection.interceptor';
import { XdebugInterceptor } from './interceptors/xdebug.interceptor';
import { messagingService } from '../services/messaging.service';
import { AppStore } from '../store';

const configureClient = (store: AppStore) => {
    httpClient.setStore(store);
    httpClient.addInterceptor(new AuthRedirectInterceptor());
    httpClient.addInterceptor(new XdebugInterceptor());
    httpClient.addInterceptor(new ErrorInterceptor());
    httpClient.addInterceptor(new DownloadInterceptor());
    httpClient.addInterceptor(new AuthHeaderInterceptor());
    httpClient.addInterceptor(new UpdateDetectionInterceptor());
    httpClient.addInterceptor(new TaxonomyHeaderInterceptor());
    httpClient.addInterceptor(new ShowProdDataHeaderInterceptor());
};

export const injectStoreToServices = (store: AppStore): void => {
    configureClient(store);
    messagingService.store = store;
    dialogService.store = store;
};
